import axios from '../axios.js'
export default {
   auth(to, from, next) {
      axios.get('auth/profile').then(()=>{
         next()
      }).catch(()=>{
         next('/')
      })
   }
}